export { useDepotsListagem } from './useDepotsListagem';
export { useDepotsNavegacao } from './useDepotsNavegacao';
